import { useTranslation } from 'react-i18next'
import { Button, Text } from '../../atoms'
import { useResendOtp } from './resend-otp.hook'

interface ResendOtpProps {
  onResend: () => void
}

export function ResendOtp({ onResend }: ResendOtpProps) {
  const { t } = useTranslation()
  const { formatted, handleResend, seconds } = useResendOtp(onResend)

  return (
    <div className="flex w-full flex-col items-start justify-center">
      <Text
        className={`text-center ${seconds > 0 ? 'text-indigo-base' : 'text-neutral-300'}`}
      >
        {formatted}
      </Text>
      <div className="flex items-stretch justify-end gap-2">
        <Text className="text-sm text-neutral-900">
          {t('login.otp.didntReceive')}
        </Text>
        <Button
          variant="link"
          size="sm"
          className="min-h-5 self-start underline"
          onClick={handleResend}
          disabled={seconds > 0}
        >
          {t('login.otp.reset')}
        </Button>
      </div>
    </div>
  )
}
